'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stepperContext = undefined;

var _react = require('react');

/**
 * The stepper context as PropTypes to be consumed by React
 */
var stepperContext = exports.stepperContext = {
    pages: _react.PropTypes.array,
    currentPage: _react.PropTypes.number,
    canAdvance: _react.PropTypes.bool,
    canFinish: _react.PropTypes.bool,
    canReverse: _react.PropTypes.bool,
    setPageIndex: _react.PropTypes.func
};
//# sourceMappingURL=entities.js.map



//////////////////
// WEBPACK FOOTER
// ./dist/src/entities.js
// module id = 236
// module chunks = 0